import React from "react";
import { Navigate } from "react-router-dom";
import { useStore } from "context/StoreContext";
import { Spinner } from "./ui/Spinner";
import { Alert } from "./ui/Alert";

interface PluginProtectedRouteProps {
  children: React.ReactNode;
  pluginId: string;
}

export const PluginProtectedRoute: React.FC<PluginProtectedRouteProps> = ({ children, pluginId }) => {
  const { isPluginEnabled, loading } = useStore();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isPluginEnabled(pluginId)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full p-6">
          <Alert variant="error">
            <h2 className="text-xl font-bold mb-2">Plugin Not Enabled</h2>
            <p className="mb-4">
              The {pluginId} plugin is not enabled for this store. Please enable it in your subscription settings to access this feature.
            </p>
            <Navigate to="/admin/subscription" replace />
          </Alert>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

